export default __webpack_public_path__ + "static/media/metaverse.ad67898a.mp4";